import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeletePeepMap as DeletePeepMapMutation,
    DeletePeepMapVariables,
    PeepMapDeleteInput,
} from 'nutshell-graphql-types';

import DELETE_PEEP_MAP from '../mutations/delete-peep-map.graphql';

export const useDeletePeepMap = (): {
    deletePeepMap: (input: PeepMapDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deletePeepMap, {loading, error}] = useMutation<
        DeletePeepMapMutation,
        DeletePeepMapVariables
    >(DELETE_PEEP_MAP);

    return {
        deletePeepMap: (input: PeepMapDeleteInput) =>
            deletePeepMap({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
